import { useContext } from 'react';

import { SipConnectionContext } from 'features/sip/contexts';

export const useSipSession = () => useContext(SipConnectionContext);
